import { Canvas, Checklist } from '@ritabygglov/core';
import { API_BASE_URL } from '../config';
import createHttpClient from './HttpClient';

function createChecklistService(baseURL: string) {
  const httpClient = createHttpClient(baseURL);

  return {
    editCanvas: async (
      canvasId: string,
      checklist: Partial<Checklist>
    ): Promise<{ message: string; canvas?: Canvas }> => {
      return httpClient.put(`/canvases/${canvasId}/checklist`, checklist);
    },
  };
}

export const checklistService = createChecklistService(API_BASE_URL!);
